var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"com-header my-header flex"},[_c('div',{staticClass:"h-left flex1"}),(!_vm.showText)?_c('div',{staticClass:"h-center"},[_c('img',{class:_vm.imgUrl ? 'img-1' : '',attrs:{"src":_vm.imgUrl,"alt":""}})]):_c('div',{staticClass:"h-center"},[_vm._v("\n\t\t\t"+_vm._s(_vm.title)+"\n        ")]),_c('div',{staticClass:"h-right flex1"})])
}
var staticRenderFns = []

export { render, staticRenderFns }